import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
interface EllipseIconProps extends SVGProps<SVGSVGElement> {
  circleFill?: string;
}
export const EllipseIcon: FC<EllipseIconProps> = t0 => {
  const $ = _c(9);
  let circleFill;
  let props;
  if ($[0] !== t0) {
    ({
      circleFill,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = circleFill;
    $[2] = props;
  } else {
    circleFill = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <title>Ellipse Icon</title>;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== circleFill) {
    t2 = <circle cx="32" cy="32" r="32" fill={circleFill} />;
    $[4] = circleFill;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t2) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none" {...props}>{t1}{t2}</svg>;
    $[6] = props;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};